import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';
import { ProjectChecklistsService } from '@portal-core/project-checklists/services/project-checklists/project-checklists.service';
import { LoadingState } from '@portal-core/util/loading-state';

@Component({
  selector: 'mc-project-checklist-deletion-form',
  templateUrl: './project-checklist-deletion-form.component.html',
  styleUrls: ['./project-checklist-deletion-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectChecklistDeletionFormComponent {
  @Input() checklist: ProjectChecklist;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() deleted: EventEmitter<void> = new EventEmitter<void>();

  savingState: LoadingState<string> = new LoadingState<string>();

  constructor(private errorService: ErrorService, private snackBar: MatSnackBar, private projectChecklistsService: ProjectChecklistsService) { }

  onCancelClicked() {
    this.cancel.emit();
  }

  onSubmit() {
    this.savingState.update(true);

    this.projectChecklistsService.deleteProjectChecklist$(this.checklist.Id, this.checklist.ProjectId).subscribe(() => {
      this.savingState.update(false);

      this.snackBar.open('The checklist has been deleted.', 'OK', { duration: 2500 });
      this.deleted.emit();
    }, error => {
      this.savingState.update(false, 'Unable to delete the checklist.', this.errorService.getErrorMessages(error));
    });
  }
}


